module.exports = __webpack_public_path__ + "static/fonts/Fact-Condensed.1268eae.woff";